import { DialogYoutubeModule } from './../dialog-youtube/dialog-youtube.module';
import { TrAccordionModule } from '@toro/common/shared/components';
import { TrackingDirectiveModule } from '@toro/common/shared/directives';
import { TransferQuestionsComponent } from './transfer-questions.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
      TransferQuestionsComponent
  ],
  imports: [
    CommonModule,
    TrackingDirectiveModule,
    TrAccordionModule,
    DialogYoutubeModule,
  ],
  exports: [
      TransferQuestionsComponent
  ]
})
export class TransferQuestionsModule { }
